import { Modal, useModals } from 'almanac-ui/Modal'
import { Workspace } from 'types'

import Account from './Account/Account'
import { startCase } from 'lodash'
import { VIEW_COMPONENTS } from './SettingsModal'
import { useLayoutEffect } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  workspace: Workspace
  onClose: () => void
  selectedItem: string
}

export const SettingsPageModal = ({ workspace, onClose, selectedItem }: Props) => {
  const SettingsViewComponent = VIEW_COMPONENTS[selectedItem] || Account
  const { isMobile } = useResponsiveDesign()
  const { closeModal, stack } = useModals()

  useLayoutEffect(() => {
    if (!isMobile && stack.length > 1) closeModal()
  }, [isMobile, closeModal, stack])

  return (
    <Modal.Root size="md" onPressOutside={onClose}>
      <Modal.Header title={startCase(selectedItem)} />
      <Modal.Content>
        <SettingsViewComponent workspace={workspace} />
      </Modal.Content>
    </Modal.Root>
  )
}
